export default {
  sinisterDamagesCount: state => {
    let items = 0
    state.sinisterSummary.forEach(damage => { items += damage.items.length })
    return (state?.sinisterSummary?.length && items) || 0
  },

  sinisterHasAddress: state => {
    return (
      state.coordinates?.lat != null &&
      state.coordinates?.lng != null &&
      state.zipCode?.length > 0
    )
  },

  existingSinister: state => {
    return state.existingSinister
  }
}
